var exports = {
  "a": "Box__bQDYuS",
  "J": "Label__3vGWaz",
};

module.exports = exports;
